import { createServerFn } from "@tanstack/react-start";
import { supabase } from "@/integrations/supabase/client";
import { z } from "zod";

export const getRecognitions = createServerFn({ method: "GET" })
  .handler(async () => {
    const { data, error } = await supabase
      .from("website_recognitions")
      .select("*")
      .eq("is_active", true)
      .order("display_order", { ascending: true });

    if (error) throw error;
    return data;
  });

export const getAdminRecognitions = createServerFn({ method: "GET" })
  .handler(async () => {
    const { data, error } = await supabase
      .from("website_recognitions")
      .select("*")
      .order("display_order", { ascending: true });

    if (error) throw error;
    return data;
  });

export const updateRecognition = createServerFn({ method: "POST" })
  .inputValidator((data) =>
    z
      .object({
        id: z.string().uuid().optional(),
        title: z.string().min(1),
        organization: z.string().min(1),
        year: z.number().int(),
        description: z.string().optional().nullable(),
        image_url: z.string().url().or(z.string().startsWith("/")),
        is_active: z.boolean().default(true),
        display_order: z.number().int().default(0),
      })
      .parse(data)
  )
  .handler(async ({ data }) => {
    const { id, ...values } = data;
    if (id) {
      const { data: updated, error } = await supabase
        .from("website_recognitions")
        .update(values)
        .eq("id", id)
        .select()
        .single();
      if (error) throw error;
      return updated;
    } else {
      const { data: created, error } = await supabase
        .from("website_recognitions")
        .insert(values)
        .select()
        .single();
      if (error) throw error;
      return created;
    }
  });

export const deleteRecognition = createServerFn({ method: "POST" })
  .inputValidator((data) => z.object({ id: z.string().uuid() }).parse(data))
  .handler(async ({ data }) => {
    const { error } = await supabase
      .from("website_recognitions")
      .delete()
      .eq("id", data.id);
    if (error) throw error;
    return { success: true };
  });
